import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex);
import user from './user/index'
import system from './system/index'
const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  modules:['user']//缓存用户仓库
})
const store = new Vuex.Store({
  modules:{
    system,
    user
  },
  plugins: [vuexLocal.plugin]
  });

export default store



// WEBPACK FOOTER //
// ./src/store/index.js